import {tailwind} from '@theme-ui/presets'
import prism from '@theme-ui/prism/presets/github.json'
import prismDark from '@theme-ui/prism/presets/dracula.json'

const anchor = {      a: {
  border: `0 !important`,
},
'.anchor': {
  visibility: 'hidden',
},
':hover': {
  '.anchor':{
  visibility: 'visible',

  }
}}
export default {
  ...tailwind,
  useColorSchemeMediaQuery: true,
  fontSizes: [
    "0.875rem",
    "1rem",
    "1.125rem",
    "1.25rem",
    "1.5rem",
    "1.75rem",
    "2.1rem",
    "2.75rem",
    "4rem"
    ],
  colors: {
    ...tailwind.colors,
    suptxt:'#000',
    text: '#333',
    subtxt: '#666',
    sectxt: '#999',
    shdtxt: '#eee',
    grad: '#E84393',
    modes: {
      dark: {
        suptxt: '#fff',
        text: '#ddd',
        subtxt: '#aaa',
        sectxt: '#777',
    shdtxt: '#444',

        background: '#252525',
    grad: '#E84393',
        primary: '#8b4367',
        ...prismDark,
      }
    }
  },

  layout: {
    container:{
      padding:[3,4],
      maxWidth: '870px',
      height: '100%',
    },
  },
  variant:{
    title: {
      article:{
        textAlign: 'center',
        margin:0,
        py:3,
        fontFamily: 'body',
        fontSize: [5, 6, 6, 7],
        fontWeight: 'bold',
        textAlign: 'center'
      }
    }
  },
  links: {
    nav: {
      px: 2,
      py: 1,
      textTransform: 'title',
      fontWeight:'normal',
      color:'text',

      ":hover":{
        color: 'sectxt',
      },

 

     

    }
  },
  fonts: {
    ...tailwind.fonts,
    body: `"IBM Plex Sans",KFGQPC,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,Arial,sans-serif`,
  },
  styles:{
    modes: {
      dark:{
        code: {
          ...prismDark
          
        }
      }
    },
    table: {
      display:'block',
      border: '1px solid',
      borderColor: 'text',
      py:3,
      textAlign: 'left',
      overflow: 'auto',
      borderCollapse: 'collapse',
      whiteSpace:'nowrap',
      maxWidth: 'max-content',
      margin: '0 auto',
    },
    th: {
      fontWeight:'bold',
      px: 3,
    },
    td: {
      py:1,
      px:3,
    },
    hr: {
      display: 'block', 
      height: '1px',
    border: 0,
    borderTop: '1px solid',
    borderColor: 'sectxt',
    margin: '1em 0',
     padding: 0,
    },
    code: {
      ...prism,
      overflowX:'auto',
      padding: 3,
      borderRadius:1,
      fontFamily: 'monospace',
      fontSize:0,
      boxShadow: 'default'
    },
    pre: {
      overflowX:'auto',
    },
    blockquote: {
      my:1,
      mx:[1,4],
      p: {
        borderLeft: '3px solid',
        borderColor: 'sectxt',
        lineHeight: '1.1rem',
      fontSize:0,
      paddingLeft:[2,3],
      textAlign: 'justify',
      color: 'suptxt'
      }
    },
    root: {
      fontFamily: 'body',
      fontWeight: 'body',
      color: `text`,
      backgroundColor: 'background',
      margin: 0,
      padding: 0,
      boxSizing: `border-box`,
      textRendering: `optimizeLegibility`,
      WebkitFontSmoothing: `antialiased`,
      MozOsxFontSmoothing: `grayscale`,
    },
    sup:{
      verticalAlign: 'super',
      fontSize: 'smaller',
    },

    a: {
      textDecoration: 'none',
      color: tailwind.colors.gray[7],
      color: 'suptxt',
      ':not(.footnote-ref, .footnote-backref)': {
        borderBottom: '1px dotted',
        borderColor: 'suptxt',
      },
      ':hover': {
        color: `sectxt`,
      },
    },
    p: {
      fontSize: 1,
      fontFamily: 'body',
      lineHeight:'body',
      marginBottom: 1,
      wordBreak: `break-word`,
      color: 'text',
      textAlign: 'justify'
    },
    strong: {
      fontWeight: '700',
    },
    mark: {
      backgroundColor: 'rgba(242,201,76,.35)',
      padding:1
    },
    img: {
      display: 'block',
      maxWidth: '99%',
      mx: 'auto',
      borderStyle: 'none',
    }, 
    h1: {
      fontFamily: 'body',
      fontSize: [5, 6, 6, 7],
      fontWeight: 'bold',
      mt: 4,
      ...anchor,
    },
    h2: {
      variant: `text.heading`,
      fontSize: [4, 5, 5, 6],
      mt: 4,
      ...anchor,
    },
    h3: {
      fontSize: [3, 4, 4, 5],
      mt: 4,
      ...anchor,
    },
    h4: {
      fontSize: [2, 3, 3, 4],
      mt: 3,
      ...anchor,
    },
    h5: {
      fontSize: [1, 2, 2, 3],
      mt: 3,
      ...anchor,
    },
    h6: {
      fontSize: 1,
      mb: 2,
      ...anchor,
    },
 
  }
}
